import { addDays, formatISO } from 'date-fns'
import { endOfWeek, startOfWeek } from '@/utils/date-fns'

export interface StatsDateRange {
  dateGte: string
  dateLt: string
}

/**
 * The date range the dashboard statistics are fetched for: the current week,
 * Monday through Sunday.
 *
 * `dateLt` is exclusive — the backend filters driver locations with
 * `datetime_start__lt=dateLt` — so it is the day *after* the last day of the
 * week. Returning the last day itself would silently drop Sunday.
 */
export function getStatsWeekRange(now: Date): StatsDateRange {
  return {
    dateGte: formatISO(startOfWeek(now), { representation: 'date' }),
    dateLt: formatISO(addDays(endOfWeek(now), 1), { representation: 'date' }),
  }
}
